import React from 'react';
import { formatoDecimal } from "../../../../utilities/formatoNumeros";
import LiquidacionDetalleTabla from './LiquidacionDetalleTabla';

const TABLE_HEAD = (
    <tr>
        <th scope="col">Id Rebate</th>
        <th scope="col">Id Venta</th>
        <th scope="col">Precio Original</th>
        <th scope="col">Precio Publicado</th>
        <th scope="col">Rebate Megatone</th>
        <th scope="col">Rebate Seller</th>
    </tr>
);

export default class RebatesDeLiquidacion extends React.Component {
    getRebatesValidos = () => {
        const { detalleRebate } = this.props;

        if (!detalleRebate || detalleRebate.length === 0) return [];

        return detalleRebate.flatMap(detalle =>
            detalle.listRebates?.length > 0
                ? detalle.listRebates.map(r => ({ ...r, idVenta: detalle.idVenta }))
                : []
        );
    };

    render = () => {
        const rebatesValidos = this.getRebatesValidos();

        return (
            <LiquidacionDetalleTabla
                title="Rebates"
                data={rebatesValidos}
                isLoading={this.props.isLoading}
                loadingMessage="Cargando rebates de la liquidacion..."
                emptyMessage="No hay rebates para esta liquidación"
                tableHead={TABLE_HEAD}
                renderRow={(rebate, i, globalIndex) => (
                    <tr
                        key={`${rebate.idVenta}-${rebate.idRebate}-${globalIndex}`}
                        className="hover-background-color"
                    >
                        <td><small>{rebate.idRebate}</small></td>
                        <td><small>{rebate.idVenta}</small></td>
                        <td><small>${formatoDecimal(rebate.precioOriginal)}</small></td>
                        <td><small>${formatoDecimal(rebate.precioPublicado)}</small></td>
                        <td><small>${formatoDecimal(rebate.rebateMegatone)}</small></td>
                        <td><small>${formatoDecimal(rebate.rebateSeller)}</small></td>
                    </tr>
                )}
            />
        );
    };
}
